import * as API from '@/services/API';

export default {
  list({ commit }, opportunityId) {
    return API.apiClient
      .get('/opportunities/' + opportunityId + '/pitches')
      .then((response) => {
        commit('SET_PITCHES_LIST', response.data);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  add({ commit, dispatch }, [opportunityId, pitches]) {
    pitches.forEach((pitch) => {
      let item = {};
      (item.property_id = pitch), (item.status = 1);
      API.apiClient
        .post('/opportunities/' + opportunityId + '/pitches', item)
        .then(() => {
          return dispatch('list', opportunityId);
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    });
  },

  delete({ commit, dispatch }, [opportunityId, pitches]) {
    pitches.forEach((pitch) => {
      API.apiClient
        .delete('/opportunities/' + opportunityId + '/pitches/' + pitch.id)
        .then(() => {
          return dispatch('list', opportunityId);
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    });
  },

  update({ commit, dispatch }, [opportunityId, pitches]) {
    pitches.forEach((pitch) => {
      API.apiClient
        .put('/opportunities/' + opportunityId + '/pitches/' + pitch.id, pitch)
        .then(() => {
          return dispatch('list', opportunityId);
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    });
  },
};
